// Placeholder pages for routes that haven't shipped yet. fn-1.29
// landed real implementations for `Agents`, `Runs`, and `Approvals`
// (see `pages/agents/`, `pages/runs/`, `pages/approvals/`). `Settings`
// stays a placeholder — per-firm configuration is a v1.x surface, out
// of scope for fn-1.29.

export function SettingsPage(): React.ReactElement {
  return (
    <section className="page page-settings">
      <h1>Settings</h1>
      <p>Per-firm settings arrive in a future task.</p>
    </section>
  );
}
